// prod
const baseURL = 'https://api.scp.smartsys.io/core';
const baseURLBayMontioring = 'https://api.scp.smartsys.io/bay-monitoring';
const env = 'production';
const sc__utility = 'https://storage.googleapis.com/sc-neptune-production-static-web-content/tiles/Common/sc__utility.js?ignoreCache=1';
const GOOGLE_MAP_KEY = 'AIzaSyCfgn2Vb_HXtEBoCaX_WimcuoKEz5Am1C0';
const CORE_END_POINT = 'https://api.scp.smartsys.io/core';
const API_KEY = 'K4nGeGEZhOBwh7N1mSK9DW8RHKGRqO2R';
export { baseURL,baseURLBayMontioring, env, sc__utility, GOOGLE_MAP_KEY, CORE_END_POINT, API_KEY };
